import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useAppData } from '@hellodarwin/core/lib/features/providers/app-data-provider';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import LanguageIcon from '@hellodarwin/icons/dist/icons/Language';
import Tooltip from 'antd/es/tooltip';
import { LanguageSwitcherStyled } from './styles';
export const SUPPORTED_LANGUAGES = ['fr', 'en'];
const LanguageSwitcher = ({ handleLanguageChange }) => {
    const { t } = useTranslations();
    const { app } = usePlatform();
    const { selectedLocale, changeLanguage } = useLocale();
    const { navCollapsed } = useAppData();
    const otherLang = SUPPORTED_LANGUAGES.find((lang) => selectedLocale !== lang);
    const clickHandler = () => {
        if (otherLang) {
            if (handleLanguageChange) {
                handleLanguageChange(otherLang);
            }
            else {
                changeLanguage(otherLang);
            }
        }
    };
    return (_jsx(Tooltip, { title: navCollapsed ? t(`lang|switch_label.${otherLang}`) : undefined, placement: "right", trigger: ['hover', 'focus'], children: _jsxs(LanguageSwitcherStyled, { type: "button", "$app": app, "$compact": navCollapsed, onClick: clickHandler, "aria-label": t(`lang|switch_label.${otherLang}`), children: [_jsx(LanguageIcon, { size: 16, "aria-hidden": true }), !navCollapsed && (_jsx(Typography, { elementTheme: "body3", textAlign: "center", children: t(`lang|switch_label.${otherLang}`) }))] }) }));
};
export default LanguageSwitcher;
